var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTypeEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 400 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.185 59.16V.13H0v59.03c0 36.436 28.355 65.972 63.333 65.972 34.978 0 63.334-29.536 63.334-65.972V.131H91.481V59.16c0 16.194-9.747 31.25-28.148 31.25-18.4 0-28.148-15.056-28.148-31.25Zm136.667 0V.13h-35.185v59.03c0 36.436 28.355 65.972 63.333 65.972 34.978 0 63.333-29.536 63.333-65.972V.131h-35.185V59.16c0 16.194-10.467 31.25-28.148 31.25-17.681 0-28.148-15.056-28.148-31.25ZM336.667.13C371.645.131 400 28.113 400 62.631s-28.355 62.5-63.333 62.5h-63.334v-125h63.334Zm1.654 31.25h-29.803v62.5h29.803c13.89 0 26.493-13.991 26.493-31.25 0-17.26-12.603-31.25-26.493-31.25Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTypeEn);
export default __webpack_public_path__ + "static/media/logo_type_en.c7b9db23798079e77dcf175c219ff03a.svg";
export { ForwardRef as ReactComponent };